import { Fragment, ReactElement } from 'react';
import ResearchBirthNonResidentNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/reasearch-birth-non-resident';

const ResearchBirthNonResidentNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchBirthNonResidentNotificationsCivilStatusShared />
    </Fragment>
  );
};

ResearchBirthNonResidentNotificationsCivilStatusPage.displayName =
  'Research Birth Non Resident Notifications Civil Status page component';

export default ResearchBirthNonResidentNotificationsCivilStatusPage;
